import { ClampToEdgeWrapping, RepeatWrapping } from 'three';

import { COLORS, DEVICE, EVENTS, LAYERS } from '../../constants.js';
import { createVideo } from '../../utils/misc.js';

import { lisa, LISA_BASE_PATH } from '../../Lisa.js';
import { globalUniforms, viewportUniforms } from '../../utils/uniforms.js';
import PBRMaterial from '../PBR/PBR.js';
import replacesFs from './replaces.fs?hotReplace';
import replacesVs from './replaces.vs?hotReplace';

export default class Screen extends PBRMaterial {
	constructor(config, caller) {
		super(config, caller);
		this.name = 'Screen';

		this.timeScale = 1;
		this.uniforms.uTime = { value: 0 };
		this.uniforms.uMouse = globalUniforms.uMouse;
		this.uniforms.uResolution = viewportUniforms.uResolution;
		this.uniforms.uRatio = viewportUniforms.uRatio;
		this.uniforms.tNoise = { value: lisa.noise.texture };
		this.uniforms.tDraw = { value: lisa.mouseComputation.renderTarget1.texture };
		this.uniforms.uMobile = viewportUniforms.uMobile;

		/* Screen controls */
		this.uniforms.uOn = { value: 1 };
		this.uniforms.uGlitchIntensity = { value: 0 };
		this.uniforms.uDisplayCode = { value: 1 };
		this.uniforms.tLeftSide = { value: config.map };
		this.uniforms.tRightSide = { value: config.map };

		this.defines.BLUE = COLORS.BLUE;

		replacesFs.use(this);
		replacesVs.use(this);
		lisa.state.on(EVENTS.ATTACH, this.#onAttach);
		lisa.state.on(EVENTS.DETACH, this.#onDetach);
	}
	#onAttach = () => {
		this.uniforms.tGlitch = { value: lisa.scene.lisa.atlas.get('glitchMap') };
		this.uniforms.tLogo = { value: lisa.scene.lisa.atlas.get('logoMap') };
		this.uniforms.tLogo.value.wrapS = this.uniforms.tLogo.value.wrapS = ClampToEdgeWrapping;
		this.uniforms.tCode = { value: createVideo(LISA_BASE_PATH+`running_code.mp4`).texture };

		lisa.state.on(EVENTS.TICK, this.#onTick);
	};

	#onTick = ({ dt }) => {
		this.uniforms.uTime.value += dt * this.timeScale;
	};

	get switchedOn() {
		return this.uniforms.uOn.value;
	}
	set switchedOn(value) {
		this.uniforms.uOn.value = value;
	}
	get glitchIntensity() {
		return this.uniforms.uGlitchIntensity.value;
	}
	set glitchIntensity(value) {
		this.uniforms.uGlitchIntensity.value = value;
	}
	get displayCode() {
		return this.uniforms.uDisplayCode.value;
	}
	set displayCode(value) {
		this.uniforms.uDisplayCode.value = value;
	}
	get leftSide() {
		return this.uniforms.tLeftSide.value;
	}
	set leftSide(value) {
		this.uniforms.tLeftSide.value = value;
	}
	get rightSide() {
		return this.uniforms.tRightSide.value;
	}
	set rightSide(value) {
		this.uniforms.tRightSide.value = value;
	}

	#onDetach() {
		lisa.state.off(EVENTS.ATTACH, this.#onAttach);
		lisa.state.off(EVENTS.DETACH, this.#onDetach);
		lisa.state.off(EVENTS.TICK, this.#onTick);
	}
}
